import { useState, useEffect } from "react";
import API_BASE_URL from "../config";
import axios from "axios";
import { isTokenValid } from "../utils/auth";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("add");
  const [blogs, setBlogs] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [blogData, setBlogData] = useState({
    title: "",
    content: "",
    category: "",
    image: null,
    imageFile: null,
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (!isTokenValid()) {
      navigate("/adminlogin");
    }
  }, [navigate]);
  // Fetch blogs when switching to "edit" tab
  useEffect(() => {
    if (activeTab === "edit") {
      fetchBlogs();
    }
  }, [activeTab]);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/posts`);
      setBlogs(res.data);
    } catch (err) {
      console.error("❌ Error fetching blogs:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files.length > 0) {
      setSelectedPost({ ...selectedPost, imageFile: files[0] });
    } else {
      setSelectedPost({ ...selectedPost, [name]: value });
    }
    // const { name, value, files } = e.target;
    // if (name === "image") {
    //   setBlogData({
    //     ...blogData,
    //     imageFile: files[0],
    //     image: URL.createObjectURL(files[0]),
    //   });
    // } else {
    //   setBlogData({ ...blogData, [name]: value });
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", blogData.title);
    formData.append("content", blogData.content);
    formData.append("category", blogData.category);
    if (blogData.imageFile) {
      formData.append("image", blogData.imageFile);
    }

    try {
      if (editIndex !== null) {
        // Update
        const id = blogs[editIndex].id;
        await axios.put(`${API_BASE_URL}/posts/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("✅ Blog updated");
      } else {
        // Create
        await axios.post(`${API_BASE_URL}/posts`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("✅ Post created");
      }

      // Refresh + reset
      fetchBlogs();
      setBlogData({
        title: "",
        content: "",
        category: "",
        image: null,
        imageFile: null,
      });
      setEditIndex(null);
      setActiveTab("edit");
    } catch (error) {
      console.error("❌ Error saving post:", error);
    }
  };
  // When user clicks "Save"
  const handleSave = async () => {
    try {
      const formData = new FormData();
      formData.append("title", selectedPost.title);
      formData.append("description", selectedPost.description);
      if (selectedPost.imageFile) {
        formData.append("image", selectedPost.imageFile); // only append if new file chosen
      }

      await axios.put(
        `http://localhost:5000/api/posts/${selectedPost.id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert("Post updated successfully!");
      // fetchPosts(); // refresh list
      setSelectedPost(null); // close editor
    } catch (err) {
      console.error("Error updating post:", err);
    }
  };
  const handleEdit = (post) => {
    if (!post) return;
    setSelectedPost(post);
  };

  const handleDelete = (post) => {
    if (!post) return;
    // delete logic...
  };

  return (
    <>
      <nav className="navbar p-3">
        <div className="container-fluid">
          <div className="d-flex">
            <a className="navbar-brand brand-name">Hello, Admin</a>
          </div>
          <div className="d-flex">
            <button className="btn btn-outline-light rounded-pill px-4">
              Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="">
        <div className="d-flex gap-3 mb-4 container-fluid px-5 py-4">
          <button
            className={`btn text-white ${
              activeTab === "add" ? "active border-0 bg-dark" : ""
            }`}
            onClick={() => setActiveTab("add")}
          >
            Add New Blog Post
          </button>
          <button
            className={`btn text-white ${
              activeTab === "edit" ? "active border-0 bg-dark" : ""
            }`}
            onClick={() => setActiveTab("edit")}
          >
            View All Blogs
          </button>
        </div>

        {activeTab === "add" && (
          <div className="container-fluid px-5">
            <h3 className="fw-normal">
              {editIndex !== null ? "Edit Blog Post" : "Add New Blog Post"}
            </h3>
            <form onSubmit={handleSubmit} className="py-4">
              {/* Title */}
              <div className="mb-3">
                <label className="form-label text-white">Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control text-white rounded-pill"
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "grey",
                  }}
                  value={blogData.title}
                  onChange={handleChange}
                />
              </div>

              {/* Content */}
              <div className="mb-3">
                <label className="form-label text-white">Content</label>
                <textarea
                  name="content"
                  rows="4"
                  className="form-control text-white rounded-4"
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "grey",
                  }}
                  value={blogData.content}
                  onChange={handleChange}
                />
              </div>

              {/* Category + Image */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label text-white">Category</label>
                  <select
                    name="category"
                    className="form-select text-white"
                    value={blogData.category}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "transparent",
                      borderColor: "grey",
                    }}
                  >
                    <option value="">Select Category</option>
                    <option value="Investments">Investments</option>
                    <option value="Tax Planning">Tax Planning</option>
                    <option value="Wealth Management">Wealth Management</option>
                    <option value="Retirement">Retirement</option>
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label text-white">Upload Image</label>
                  <input
                    type="file"
                    name="image"
                    className="form-control"
                    accept="image/*"
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-light rounded-pill px-4 py-2 my-3"
              >
                {editIndex !== null ? "Update Blog" : "Post Blog"}
              </button>
            </form>
          </div>
        )}
      </div>

      {activeTab === "edit" && (
        <div className="container-fluid px-5">
          <h3 className="fw-normal mb-4">All Blog Posts</h3>
          <div className="row">
            {blogs.length === 0 ? (
              <p className="text-white">No blogs available.</p>
            ) : (
              blogs.map((blog) => (
                <div className="col-md-6 col-lg-4 mb-4" key={blog.id}>
                  <div className="card h-100 bg-dark text-white border-light shadow-sm">
                    {blog.image_url && (
                      <img
                        src={`http://localhost:5000${blog.image_url}`} // same as Blogs.jsx
                        alt={blog.title}
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                    )}
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title">{blog.title}</h5>
                      <p className="card-text">
                        {blog.content.length > 100
                          ? blog.content.slice(0, 100) + "..."
                          : blog.content}
                      </p>
                      <div className="mb-2">
                        {blog.category &&
                          blog.category.split(",").map((cat, idx) => (
                            <span key={idx} className="badge bg-secondary me-1">
                              {cat.trim()}
                            </span>
                          ))}
                      </div>
                      <div className="mt-auto d-flex justify-content-between">
                        <button
                          className="btn btn-outline-light btn-sm"
                          onClick={() => handleEdit(blog)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDelete(blog.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
      {selectedPost && (
        <div
          className="modal show fade"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title">Edit Post</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedPost(null)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const formData = new FormData();
                    formData.append("title", selectedPost.title);
                    formData.append("content", selectedPost.content); // ✅ use content
                    formData.append(
                      "category",
                      Array.isArray(selectedPost.category)
                        ? selectedPost.category.join(",")
                        : selectedPost.category || ""
                    );

                    if (selectedPost.newImage) {
                      formData.append("image", selectedPost.newImage);
                    }

                    try {
                      await axios.put(
                        `${API_BASE_URL}/posts/${selectedPost.id}`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                      );
                      alert("Post updated!");
                      fetchBlogs(); // ✅ refresh with correct function
                      setSelectedPost(null);
                    } catch (err) {
                      console.error("❌ Update error:", err);
                    }
                  }}
                >
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedPost.title}
                      onChange={(e) =>
                        setSelectedPost({
                          ...selectedPost,
                          title: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Content</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={selectedPost.content}
                      onChange={(e) =>
                        setSelectedPost({
                          ...selectedPost,
                          content: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Upload New Image</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) =>
                        setSelectedPost({
                          ...selectedPost,
                          newImage: e.target.files[0],
                        })
                      }
                    />
                  </div>

                  {/* Modal Footer */}
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setSelectedPost(null)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminDashboard;
